var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import merge from 'deepmerge';
import configureTooltip from '../tooltip/main';
import constants from '../../constants';
import chartUtils from '../../../utils/chart-utils';

var buildPyramidConfiguration = function buildPyramidConfiguration(seriesConfig, seriesDataObj, customConfig) {
    var _style;

    var pyramidChartData = seriesDataObj["Pyramid Chart"];
    var START_INDEX = 0;
    var END_INDEX = seriesConfig.DisplayCount && seriesConfig.DisplayCount > 0 ? seriesConfig.DisplayCount : pyramidChartData.length;
    var PYRAMID_CHART = constants.chartTypes.PYRAMID_CHART;

    var ValueFormat = seriesConfig.ValueFormat,
        CurrencySymbol = seriesConfig.CurrencySymbol,
        BaseFormat = seriesConfig.BaseFormat,
        ShowLabels = seriesConfig.ShowLabels,
        ShowCategoryLabels = seriesConfig.ShowCategoryLabels;


    var data = pyramidChartData.slice(START_INDEX, END_INDEX).map(function (obj) {
        var value = void 0;
        var ignoreBlanks = seriesConfig.IgnoreBlanks;
        var valueField = seriesConfig.SeriesType.toLowerCase() == PYRAMID_CHART.toLowerCase() ? seriesConfig.ValueField : valueField;
        var ignoreBlanksValue = ignoreBlanks ? null : 0;

        if ([PYRAMID_CHART.toLowerCase()].includes(seriesConfig.SeriesType.toLowerCase())) value = Math.abs(obj[valueField]);else value = obj[valueField] ? obj[valueField] / 1 : ignoreBlanksValue;

        return _extends({
            name: obj[seriesConfig.XAxisField],
            y: value,
            value: value,
            crumbValue: obj[seriesConfig.CrumbFieldName]
        }, obj, obj.tooltip, {
            high: obj.Max,
            className: obj[valueField] < 0 ? 'negative-value' : undefined
        });
    });

    return merge({
        data: data,
        dataLabels: {
            style: (_style = {
                fontSize: '10px'
            }, _style['fontSize'] = '1vh', _style),
            enabled: ShowCategoryLabels || ShowLabels ? true : false,
            formatter: function formatter() {
                var valueLabel = chartUtils.format(this.y, ValueFormat, CurrencySymbol, null, BaseFormat);
                var categoryLabel = this.point.options.name;
                var label = '';

                if (ShowCategoryLabels && ShowLabels) label = categoryLabel + ': ' + valueLabel;else if (ShowCategoryLabels) label = categoryLabel;else if (ShowLabels) label = valueLabel;
                return label;
            },
            softConnector: true
        },
        colors: ['#666', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        tooltip: configureTooltip(PYRAMID_CHART, _extends({}, seriesConfig, { ValueFormat: ValueFormat, CurrencySymbol: CurrencySymbol }))
    }, customConfig);
};
export default buildPyramidConfiguration;